// categoriesData.slugs.js
// Auto-generated variant that adds `slug` and consistent slug-based `link` fields.
// Slugs are lowercase, ASCII-only (accents stripped), spaces -> '-', and punctuation removed.
// Links are built as: /marketplace/<slug>/<slug>/...
// You can import this in place of the original categoriesData.js.

import empaque from "../../images/marketplace/EMPAQUE.png";
import pallets from "../../images/marketplace/png/empaque/PALLETS.png";
import carton from "../../images/marketplace/png/empaque/CARTON.png";
import fleje from "../../images/marketplace/png/empaque/FLEJE.png";
import esquineros from "../../images/marketplace/png/empaque/ESQUINEROS.png";
import relleno from "../../images/marketplace/png/empaque/RELLENOS.png";
import otrosem from "../../images/marketplace/png/empaque/OTROS.png";
import rh from "../../images/marketplace/RH.png";
import bolsa from "../../images/marketplace/png/recursos/REGALOS.png";
import papeleria from "../../images/marketplace/png/recursos/PAPELERIA.png";
import uniforme from "../../images/marketplace/png/recursos/UNIFORMES.png";
import gafete from "../../images/marketplace/png/recursos/GAFETES.png";
import imprenta from "../../images/marketplace/png/recursos/IMPRENTA.png";
import botiquin from "../../images/marketplace/png/recursos/BOTIQUIN.png";
import sumElec from "../../images/marketplace/SE.png";
import cableado from "../../images/marketplace/png/suministros/CABLEADO.png";
import boton from "../../images/marketplace/png/suministros/BOTONERIA.png";
import andon from "../../images/marketplace/png/suministros/ANDON.png";
import switches from "../../images/marketplace/png/suministros/SWITCHES.png";
import fusible from "../../images/marketplace/png/suministros/FUSIBLES.png";
import actuador from "../../images/marketplace/png/suministros/ACTUADORES.png";
import tablilla from "../../images/marketplace/png/suministros/TABLILLAS.png";
import plc from "../../images/marketplace/png/suministros/PLCs.png";
import toolcrib from "../../images/marketplace/TOOLCRIB.png";
import herrMec from "../../images/marketplace/png/tool crib/HERRAMIENTAMECANICA.png";
import ehs from "../../images/marketplace/png/tool crib/EHS.png";
import herrEle from "../../images/marketplace/png/tool crib/HERRAMIENTAELECTRICA.png";
import tornillo from "../../images/marketplace/png/tool crib/TORNILLOSYTUERCAS.png";
import ferreteria from "../../images/marketplace/png/tool crib/FERRETERIA.png";
import limpieza from "../../images/marketplace/png/tool crib/LIMPIEZA.png";
import technology from "../../images/marketplace/SISTEMAS.png";
import computo from "../../images/marketplace/png/sistemas/EQUIPODECOMPUTO.png";
import impresora from "../../images/marketplace/png/sistemas/IMPRESORAS.png";
import servidor from "../../images/marketplace/png/sistemas/SERVIDORES.png";
import periferico from "../../images/marketplace/png/sistemas/PERIFERICOS.png";
import redes from "../../images/marketplace/png/sistemas/REDES.png";
import otrossis from "../../images/marketplace/png/sistemas/OTROS.png";

const removeAccents = (str) =>
  str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

const makeSlug = (str) => {
  const ascii = removeAccents(String(str));
  return ascii
    .toLowerCase()
    .replace(/&/g, ' y ')
    .replace(/['"()]/g, '')
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, ''); 
};

const withMeta = (node, parentSlugs = []) => {
  const label = node.category ?? node.name;
  const slug = node.slug ?? makeSlug(label);
  const segments = [...parentSlugs, slug];
  const link = `/marketplace/${segments.join('/')}`;
  return {
    ...node,
    slug,
    link,
    subCategories: node.subCategories
      ? node.subCategories.map((c) => withMeta(c, segments))
      : undefined,
  };
};

const base = [
  {
    key: 1,
    category: "Empaque",
    description: "Materiales de embalaje y protección",
    img: empaque,
    subCategories: [
      { name: "Pallets", img: pallets, description: "En Empaques" },
      { name: "Cartón", img: carton, description: "En Empaques" },
      { name: "Fleje", img: fleje, description: "En Empaques" },
      { name: "Esquineros", img: esquineros, description: "En Empaques" },
      { name: "Relleno", img: relleno, description: "En Empaques" },
      { name: "Otros", img: otrosem, description: "En Empaques" },
    ],
  },
  {
    key: 2,
    category: "Recursos Humanos",
    description: "Soluciones para tu equipo de trabajo",
    img: rh,
    subCategories: [
      {
        name: "Regalos",
        img: bolsa,
        description: "En Recursos Humanos",
        subCategories: [
          {
            name: "Promocionales y Regalos Corporativos",
            description: "En Recursos Humanos",
            subCategories: [
              {
                name: "Artículos promocionales",
                description: "En Promocionales y Regalos Corporativos",
                subCategories: [
                  { name: "Tazas y termos", description: "En Artículos promocionales" },
                  { name: "Cilindros y botellas", description: "En Artículos promocionales" },
                  { name: "Plumas y libretas", description: "En Artículos promocionales" },
                  { name: "Artículos eco-friendly", description: "En Artículos promocionales" },
                ],
              },
              { name: "Mochilas y maletas personalizadas", description: "En Resursos Humanos" },
              {
                name: "Artículos de temporada",
                subCategories: [
                  { name: "Navidad", description: "En Articulos de temporada" },
                  { name: "Aniversarios de empresa", description: "En Articulos de temporada" },
                  { name: "Ferias y campañas internas", description: "En Articulos de temporada" },
                ],
              },
              { name: "Kits de bienestar (gym, lunch, home-office)", description: "En Recursos Humanos" },
            ],
          },
        ],
      },
      {
        name: "Papelería",
        img: papeleria,
        description: "Papelería y suministros",
      },
      {
        name: "Uniformes",
        img: uniforme,
        description: "Ropa laboral y corporativa",
        subCategories: [
          {
            name: "Uniformes y Vestimenta Corporativa",
            description: "",
            subCategories: [
              {
                name: "Chalecos de seguridad",
                subCategories: [
                  { name: "Alta visibilidad" },
                  { name: "Reflejantes" },
                  { name: "Antirrobo" },
                ],
              },
              { name: "Camisetas y polos con logo" },
              { name: "Gorras y sudaderas personalizadas" },
              { name: "Chamarras corporativas" },
              { name: "Kits de bienvenida (induction kits)" },
            ],
          },
        ],
      },
      {
        name: "Gafetes",
        img: gafete,
        description: "Identificación y control de acceso",
        subCategories: [
          {
            name: "Control y Seguridad de Personal",
            subCategories: [
              {
                name: "Sellos de seguridad",
                subCategories: [
                  { name: "Tipo cable" },
                  { name: "Cincho plástico" },
                  { name: "Metálico" },
                  { name: "Indicadores de manipulación" },
                ],
              },
              { name: "Credenciales y gafetes" },
              { name: "Porta-gafetes y lanyards" },
            ],
          },
        ],
      },
      {
        name: "Imprenta",
        description: "Soluciones de impresión y diseño",
        img: imprenta,
      },
      {
        name: "Botiquín",
        description: "Salud y cuidado inmediato",
        img: botiquin,
      },
    ],
  },
  {
    key: 3,
    category: "Suministros Eléctricos",
    description: "Conexiones, cableado y más",
    img: sumElec,
    subCategories: [
      { name: "Cableado", img: cableado, description: "" },
      { name: "Botonería", img: boton, description: "" },
      { name: "Andon", img: andon, description: "" },
      { name: "Switches", img: switches, description: "" },
      { name: "Fusibles", img: fusible, description: "" },
      { name: "Actuadores", img: actuador, description: "" },
      { name: "Tablillas", img: tablilla, description: "" },
      { name: "PLC's", img: plc, description: "" },
    ],
  },
  {
    key: 4,
    category: "Tool Crib",
    description: "Herramientas y equipo de taller",
    img: toolcrib,
    subCategories: [
      { name: "EHS", img: ehs, description: "" },
      { name: "Herramienta Mecánica", img: herrMec, description: "" },
      { name: "Herramienta Eléctrica", img: herrEle, description: "" },
      { name: "Tornillos y Tuercas", img: tornillo, description: "" },
      { name: "Ferretería", img: ferreteria, description: "" },
      { name: "Limpieza", img: limpieza, description: "" },
    ],
  },
  {
    key: 5,
    category: "Tecnología",
    description: "Hardware para tu negocio",
    img: technology,
    subCategories: [
      { name: "Equipo de Cómputo", img: computo, description: "" },
      { name: "Impresoras", img: impresora, description: "" },
      { name: "Servidores", img: servidor, description: "" },
      { name: "Periféricos", img: periferico, description: "" },
      { name: "Redes", img: redes, description: "" },
      { name: "Otros", img: otrossis, description: "" },
    ],
  },
];

export const CategoriesData = base.map((n) => withMeta(n));

export default CategoriesData;
